export interface StoreView {
    region_id: number;
    region_name: string;
    store_code: string;
    scope: string; // Store view
    sort_order: number;
}

export enum StoreViewEnum {
    HN = 'hn_gen_two',
    HCM = 'hcm_gen_two',
}

export const STORE_CODES: string[] = [StoreViewEnum.HN, StoreViewEnum.HCM];

export function getValidStoreCode(storeCode: string) {
    if (STORE_CODES.includes(storeCode)) {
        return storeCode;
    }
    return StoreViewEnum.HN;
}
